export const KYC_VERIFICATION_LINK = '/account/kyc-verification';
